import useUXStore from "../../api/ux/store"
import ButtonControl from "../../components/ButtonControl"
import CAccordion from "../../components/CAccordion"
import EditorControl from "../../components/EditorControl"
import InputItem from "../../components/InputItem"
import { CompanyData } from "../../api/companies/data"
import BranchItem from "./BranchItem"
import InviteOwner from "./InviteOwner"
import { useAuth } from "../../api/auth/store"
import { SUPPORT_ROLE } from "../../constants"


const defaultCom: CompanyData = { id: "testapp", name: "Test App" }



const BranchControl = ({ com = defaultCom, editable = true }) => {
    const { refreshDialog } = useUXStore(state => state)

    const onView = () => {
        refreshDialog({
            id: "branchView",
            visible: true,
            title: com.name + " Branches",
            content: <BranchItem com={com.id} editable={editable} />,
            className: "modal-large",
            onConfirm: undefined,
        }, true)
    }

    return <ButtonControl text="Branches" variant="outline-primary" buttonLabel="View" onClicked={onView} />
}

const CompanyItem = ({
    com = defaultCom,
    onDelete = (com: string) => { },
    onUpdate = async (com: CompanyData) => { },
}) => {
    const { refreshDialog } = useUXStore(state => state)
    const onDeleteCom = (data: CompanyData) => {
        refreshDialog({
            id: "deleteCom",
            title: "Delete " + data.name,
            visible: true,
            content: <div>Are you sure you want to delete <b>{data.name}</b>?</div>,
            onConfirm() {
                onDelete(data.id!)
            },
        }, true)
    }

    const onApply = async (newdata: any) => {
        onUpdate(newdata)
    }
    const { hasRole } = useAuth(state => state)
    const editable = !hasRole(SUPPORT_ROLE)

    return <CAccordion label={com.name}>
        <EditorControl editable={editable} defaultData={com} onApply={onApply}>
            {(data, onChanged, edit) => <>
                <InputItem edit={false} text="Id" value={data.id} />
                <InputItem edit={edit} text="Name" id="name" value={data.name} onChanged={onChanged} />
                <BranchControl com={com} editable={editable} />
                {editable && <InviteOwner access={data.access} com={com.id!} />}
                {edit && <ButtonControl labelColor="red"
                    text="Delete App"
                    buttonLabel="Delete"
                    variant="outline-danger"
                    onClicked={() => onDeleteCom(data)} />}
            </>}
        </EditorControl>
    </CAccordion>
}

export default CompanyItem